import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { getStyles } from '../../../shared/utility';
import Shiitake from 'shiitake';

import Button from '../Button/Button';

import localStyles from './TextClamp.scss';
const styles = getStyles(localStyles);

class TextClamp extends Component {
    /* * * * * * * * *
     * REACT METHODS *
     * * * * * * * * */
    constructor(props) {
        super(props);
        this.state = {
            clamped: props.expanded ? false : true,
            maxLines: props.lines && Number.isInteger(props.lines) ? Math.abs(props.lines) : 3,
            showButton: true
        };

        this.refClamp = React.createRef();
        this.refOriginalContent = React.createRef();
    }

    componentDidMount(){
        if(this.props.forceHeight){
            this.forceHeight();
            window.addEventListener('resize', this.forceHeight);
        }
        if(this.props.button){
            this.checkClamping();
            window.addEventListener('resize', this.checkClamping);
        }
    }

    componentWillUnmount(){
        if(this.props.forceHeight){
            window.removeEventListener('resize', this.forceHeight);
        }
        if(this.props.button){
            window.removeEventListener('resize', this.checkClamping);
        }
    }

    getMaxHeight = () => {
        const lineHeight = parseFloat(getComputedStyle(this.refClamp.current).lineHeight);
        return Math.floor(lineHeight * this.state.maxLines);
    }

    forceHeight = () => {
        this.refClamp.current.style.height = `${this.getMaxHeight()}px`;
    }

    checkClamping = () => {
        if(!this.refOriginalContent.current){
            return;
        }

        const originalContentHeight = this.refOriginalContent.current.getBoundingClientRect().height;

        if(originalContentHeight <= this.getMaxHeight()){
            this.setState({ clamped: false, showButton: false });
        }
    }


    /* * * * * * * * * *
     * EVENT HANDLERS  *
     * * * * * * * * * */
    toggleClamp = () => this.setState({ clamped: !this.state.clamped });

    /* * * * * * * * * *
     * CONTENT METHODS *
     * * * * * * * * * */
    addLineBreaks = (string) => /\n/.test(string) ? (
        <Fragment>{string.split('\n').map((line, index) => (<Fragment key={index}>{index?<br/>:null}{line}</Fragment>))}</Fragment>
    ) : string;

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        const shiitakeAttributes = {
            lines: this.state.maxLines,
            throttleRate: 300,
            className: styles('clamp__shiitake'),
            tagName: (this.props.tagName || (this.props.button ? 'p' : 'span'))
        };

        if(this.props.button){
            shiitakeAttributes.overflowNode = <span className={styles('clamp__gradient')}></span>;
        }

        const content = this.props.button && !this.state.clamped ?
            <p>{this.addLineBreaks(this.props.children)}</p> :
            <Shiitake {...shiitakeAttributes}>{this.props.children}</Shiitake>;

        const originalContent = this.props.button ?
            <p className={styles('clamp__original-content')} ref={this.refOriginalContent}>{this.addLineBreaks(this.props.children)}</p> : null;

        const HtmlTag = this.props.button ? 'div' : 'span';
        const classes = ['clamp']
            .concat(this.props.button && this.state.clamped ? 'clamp--clamped' : null)
            .concat(this.props.classes);

        const button = this.props.button && this.state.showButton ? (
            <Button
                modifiers={['collapsed', 'transparent']}
                classes={styles('c--brand', 'clamp-button')}
                events={{ click: this.toggleClamp }}
            >
                {this.state.clamped ? (this.props.showMoreText || '+ Show More') : (this.props.showLessText || '- Show Less')}
            </Button>
        ) : null;

        return (
            <Fragment>
                <HtmlTag
                    ref={this.refClamp}
                    className={styles(classes)}
                >
                    {content}
                    {button}
                    {originalContent}
                </HtmlTag>
            </Fragment>
        );
    }
}

TextClamp.propTypes = {
    // properties
    children: PropTypes.node.isRequired,

    classes: PropTypes.string,
    forceHeight: PropTypes.bool,
    lines: PropTypes.number,
    tagName: PropTypes.string,
    button: PropTypes.bool,
    expanded: PropTypes.bool,
    showMoreText: PropTypes.string,
    showLessText: PropTypes.string
};

export default TextClamp;



// WEBPACK FOOTER //
// ./src/components/UI/TextClamp/TextClamp.js